<script>
export default {
  name: "MenuItem",
  functional: true,
  props: {
    icon: {
      type: String,
      default: ""
    },
    title: {
      type: String,
      default: ""
    }
  },
  render(h, context) {
    const { icon, title } = context.props;
    // console.log(title);
    const vnodes = [];
    if (title) {
      vnodes.push(<span slot="title">{title}</span>);
      vnodes.push(<svg-icon class={title} icon-class={title} />);
    }

    // if (title) {
    //   vnodes.push(<span slot="title">{title}</span>);
    // }
    return vnodes;
  }
};
</script>

<style>
/* .sub-el-icon {
  width: 20px;
  height: 20px;
} */
.sub-el-icon {
  width: 1em;
  height: 1em;
}
</style>



// WEBPACK FOOTER //
// src/layout/components/Sidebar/Item.vue